export default __webpack_public_path__ + "static/media/s4_title20bbutton.9828ef39.png";